import { SORT_DESC } from '@/state/types/query'

export default {
  sort: 'created_at',
  order: SORT_DESC,
  page: 1,
  perPage: 10,
  filter: {},
}



// WEBPACK FOOTER //
// ./state/static/newsletters.js